import { api } from '@marketplace-web/core-api/core-api-client-util'

import { GetTermsAndConditionsResp } from '../types/dto/terms-and-conditions'
import { GetTermsAndConditionsContentResp } from '../transformers/terms-and-conditions'

export const getTermsAndConditions = () =>
  api.get<GetTermsAndConditionsResp>('/terms_and_conditions')

export const getTermsAndConditionsContent = () =>
  api.get<GetTermsAndConditionsContentResp>('/terms_and_conditions/content')

export const acceptTermsAndConditions = (id: number) => api.put(`/users/${id}/agree_terms`)
